import CultureGrowthPhaseService from '../../service/CultureGrowthPhaseService'

const newGrowthPhase = {
    phase_type: null,
}

const newGrowthPhaseItem = {
    growth_phase_id: null,
    growth_index: null,
    name: null,
    locale: {
        en_name: null,
        et_name: null,
        fi_name: null,
        lt_name: null,
        la_name: null,
    },
}

const initialState = {
    growthPhases: [],
    selectedGrowthPhase: null,
    growthPhaseItems: [],
    newGrowthPhase: { ...newGrowthPhase },
    newGrowthPhaseItem: { ...newGrowthPhaseItem },
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        // Growth Phase actions
        async fetchGrowthPhases({ commit }) {
            try {
                const resp = await CultureGrowthPhaseService.getGrowthPhases()
                if (resp.status === 200) {
                    commit('setGrowthPhases', resp.data.table_data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async createGrowthPhase({ state, dispatch, commit }) {
            try {
                const resp = await CultureGrowthPhaseService.createGrowthPhase(state.newGrowthPhase)
                if (resp.status === 201) {
                    commit('resetNewGrowthPhase')
                    dispatch('fetchGrowthPhases')
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Growth phase created',
                        type: 'success',
                    }, { root: true })
                }
            } catch (e) {
                console.log(e)
                dispatch('app/showSnackbar', {
                    bool: true,
                    message: 'Error creating growth phase',
                    type: 'error',
                }, { root: true })
            }
        },
        async updateGrowthPhase({ dispatch }, data) {
            try {
                const resp = await CultureGrowthPhaseService.updateGrowthPhase(data)
                if (resp.status === 200) {
                    dispatch('fetchGrowthPhases')
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Growth phase updated',
                        type: 'success',
                    }, { root: true })
                }
            } catch (e) {
                console.log(e)
                dispatch('app/showSnackbar', {
                    bool: true,
                    message: 'Error updating growth phase',
                    type: 'error',
                }, { root: true })
            }
        },
        async deleteGrowthPhase({ dispatch }, id) {
            try {
                const resp = await CultureGrowthPhaseService.deleteGrowthPhase(id)
                if (resp.status === 200) {
                    dispatch('fetchGrowthPhases')
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Growth phase deleted',
                        type: 'success',
                    }, { root: true })
                }
            } catch (e) {
                console.log(e)
                dispatch('app/showSnackbar', {
                    bool: true,
                    message: 'Error deleting growth phase',
                    type: 'error',
                }, { root: true })
            }
        },

        // Growth Phase Item actions
        async fetchGrowthPhaseItems({ commit }, growthPhaseId) {
            try {
                const resp = await CultureGrowthPhaseService.getGrowthPhaseItems(growthPhaseId)
                if (resp.status === 200) {
                    commit('setGrowthPhaseItems', resp.data.table_data)
                    commit('setSelectedGrowthPhase', resp.data.growth_phase)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async createGrowthPhaseItem({ state, dispatch, commit }) {
            try {
                // Save the growth_phase_id before resetting the form
                const growthPhaseId = state.newGrowthPhaseItem.growth_phase_id
                const resp = await CultureGrowthPhaseService.createGrowthPhaseItem(state.newGrowthPhaseItem)
                if (resp.status === 201) {
                    commit('resetNewGrowthPhaseItem')
                    // Use the saved growthPhaseId to fetch items
                    dispatch('fetchGrowthPhaseItems', growthPhaseId)
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Growth phase item created',
                        type: 'success',
                    }, { root: true })
                }
            } catch (e) {
                console.log(e)
                dispatch('app/showSnackbar', {
                    bool: true,
                    message: 'Error creating growth phase item',
                    type: 'error',
                }, { root: true })
            }
        },
        async updateGrowthPhaseItem({ dispatch }, data) {
            try {
                const resp = await CultureGrowthPhaseService.updateGrowthPhaseItem(data)
                if (resp.status === 200) {
                    dispatch('fetchGrowthPhaseItems', data.growth_phase_id)
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Growth phase item updated',
                        type: 'success',
                    }, { root: true })
                }
            } catch (e) {
                console.log(e)
                dispatch('app/showSnackbar', {
                    bool: true,
                    message: 'Error updating growth phase item',
                    type: 'error',
                }, { root: true })
            }
        },
        async deleteGrowthPhaseItem({ dispatch, state }, id) {
            try {
                const resp = await CultureGrowthPhaseService.deleteGrowthPhaseItem(id)
                if (resp.status === 200) {
                    if (state.selectedGrowthPhase) {
                        dispatch('fetchGrowthPhaseItems', state.selectedGrowthPhase.id)
                    }
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Growth phase item deleted',
                        type: 'success',
                    }, { root: true })
                }
            } catch (e) {
                console.log(e)
                dispatch('app/showSnackbar', {
                    bool: true,
                    message: 'Error deleting growth phase item',
                    type: 'error',
                }, { root: true })
            }
        },
    },
    mutations: {
        setGrowthPhases(state, data) {
            state.growthPhases = data
        },
        setSelectedGrowthPhase(state, data) {
            state.selectedGrowthPhase = data
        },
        setGrowthPhaseItems(state, data) {
            state.growthPhaseItems = data
        },
        resetNewGrowthPhase(state) {
            state.newGrowthPhase = { ...newGrowthPhase }
        },
        resetNewGrowthPhaseItem(state) {
            state.newGrowthPhaseItem = { ...newGrowthPhaseItem }
        },
        setNewGrowthPhaseItem(state, data) {
            state.newGrowthPhaseItem = { ...data }
        },
    },
    getters: {
        getGrowthPhaseById: (state) => (id) => {
            return state.growthPhases.find(phase => phase.id === id)
        },
    },
}